import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { getPermissionRestaurant, isEmptyObject } from '../../../utils/utils';
import {
  getListReportRestaurantInfo,
  getListReportRestaurantIds,
  openTransactionRestaurantReport,
  getTransaction,
  changeTableActivePageTransaction,
  changeTablePageSizeTransaction,
  handleChangeFiltersTransaction,
  exportRestaurantReport,
} from './actions';
import { trans } from '../../../localization/index';
import ReportRestaurantFilter from './components/ReportRestaurantFilter';
import ReportRestaurantTable from './components/ReportRestaurantTable';
import {
  changeFilters,
  changeTableActivePage,
  changeTablePageSize,
  closeDialogGeneric,
} from '../../../redux/genericAction';
import { EnumMerchantPermission, EnumPage } from '../../../constants/enum';
import TransactionRestaurantModal from './TransactionRestaurant/TransactionRestaurantModal';

class ReportRestaurant extends Component {
  componentDidMount() {
    const {
      currentRestaurant,
      handleChangeFiltersConnect,
      getListReportRestaurantIdsConnect,
    } = this.props;
    if (!isEmptyObject(currentRestaurant)) {
      const listRestaurantAllow = getPermissionRestaurant(
        this.props.restaurants,
        EnumMerchantPermission.REPORT_ALL.id,
      );
      if (
        listRestaurantAllow.find(
          restaurant =>
            restaurant.restaurant_id === currentRestaurant.restaurant_id,
        )
      ) {
        handleChangeFiltersConnect('restaurant', {
          label: currentRestaurant.name,
          value: currentRestaurant.restaurant_id,
        });
      }
    }
    handleChangeFiltersConnect('isShowTotal', false);
    getListReportRestaurantIdsConnect();
  }

  render() {
    const {
      restaurants,
      reportRestaurant,
      handleChangeFiltersConnect,
      getListReportRestaurantInfoConnect,
      getListReportRestaurantIdsConnect,
      changeTablePageSizeConnect,
      changeTableActivePageConnect,
      closeDialogGenericConnect,
      openTransactionRestaurantReportConnect,
      changeTableActivePageTransactionConnect,
      changeTablePageSizeTransactionConnect,
      handleChangeFiltersTransactionConnect,
      exportRestaurantReportConnect,
    } = this.props;
    const { filters, table, dialog } = reportRestaurant;
    return (
      <React.Fragment>
        <h2 className="title-page">{trans('mod_report_restaurant')}</h2>
        <ReportRestaurantFilter
          filters={filters}
          restaurants={restaurants}
          handleSearch={getListReportRestaurantIdsConnect}
          handleChangeFilters={handleChangeFiltersConnect}
          exportRestaurantReport={exportRestaurantReportConnect}
        />
        <ReportRestaurantTable
          table={table}
          filters={filters}
          getList={getListReportRestaurantInfoConnect}
          changePageSize={changeTablePageSizeConnect}
          changeActivePage={changeTableActivePageConnect}
          openTransactionRestaurantReport={openTransactionRestaurantReportConnect}
        />
        <TransactionRestaurantModal
          dialog={dialog}
          changeActivePage={changeTableActivePageTransactionConnect}
          changePageSize={changeTablePageSizeTransactionConnect}
          closeDialogGeneric={closeDialogGenericConnect}
          handleChangeFilters={handleChangeFiltersTransactionConnect}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  restaurants: state.app.restaurants,
  currentRestaurant: state.setting.currentRestaurant,
  reportRestaurant: state.report.restaurant,
});

const mapDispatchToProps = (dispatch) => {
  const PAGE = EnumPage.REPORT_RESTAURANT.id;
  return {
    changeTablePageSizeConnect: pageSize =>
      dispatch(changeTablePageSize(PAGE, pageSize)),
    changeTableActivePageConnect: activePage =>
      dispatch(changeTableActivePage(PAGE, activePage)),
    handleChangeFiltersConnect: (name, value) => {
      dispatch(changeFilters(PAGE, name, value));
    },
    getListReportRestaurantInfoConnect: ids =>
      dispatch(getListReportRestaurantInfo(ids)),
    getListReportRestaurantIdsConnect: () => {
      dispatch(getListReportRestaurantIds());
    },
    closeDialogGenericConnect: () => {
      dispatch(closeDialogGeneric(PAGE));
    },
    openTransactionRestaurantReportConnect: (restaurant, type) => {
      dispatch(openTransactionRestaurantReport(restaurant, type));
    },
    changeTableActivePageTransactionConnect: (activePage) => {
      dispatch(changeTableActivePageTransaction(activePage));
    },
    changeTablePageSizeTransactionConnect: (pageSize) => {
      dispatch(changeTablePageSizeTransaction(pageSize));
    },
    handleChangeFiltersTransactionConnect: (name, value) => {
      dispatch(handleChangeFiltersTransaction(name, value));
      dispatch(getTransaction());
    },
    exportRestaurantReportConnect: () => {
      dispatch(exportRestaurantReport());
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ReportRestaurant),
);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportRestaurant/ReportRestaurant.jsx